import * as React from "react";
import { useDispatch } from "react-redux";
import { routes } from "../../appRoutingHelpers";
import { StyledText } from "../../assets/typography/typography";
import { Tab } from "../../components/Tab";
import { OrganizationKeyName } from "../../model/Organization";
import * as commonActions from "../common/commonActions";

interface Props {
  organization: OrganizationKeyName;
  venueId: string | null | undefined;
  shopId: string | null | undefined;
}

const VenueShopNav: React.FC<Props> = ({ organization, venueId, shopId }) => {
  const dispatch = useDispatch();

  if (shopId === "all-shops") {
    return null;
  }

  return (
    <div className="row mb-5">
      <div className="col-12">
        <ul className="nav nav-pills" style={{ gap: "8px" }}>
          {venueId ? (
            <>
              <li>
                <Tab to={routes.venueEdit(organization, venueId)}>
                  Restaurant information
                </Tab>
              </li>
              <li>
                <Tab
                  to={
                    shopId
                      ? routes.shopProductListForShop(organization, shopId)
                      : routes.shopNewWithVenue(organization, venueId || "")
                  }
                >
                  Settings
                </Tab>
              </li>
            </>
          ) : (
            <>
              <li>
                <Tab to={routes.venueNew(organization)}>
                  Restaurant information
                </Tab>
              </li>
              <li className="nav-item">
                <span
                  className="nav-link"
                  onClick={() => {
                    dispatch(
                      commonActions.showToastAction(
                        "info",
                        "Please create venue first"
                      )
                    );
                  }}
                >
                  <StyledText className="bodyTextRegular mb-0">
                    Settings
                  </StyledText>
                </span>
              </li>
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default VenueShopNav;
